import { render, staticRenderFns } from "./DeckImage.vue?vue&type=template&id=475c20a3&"
import script from "./DeckImage.vue?vue&type=script&lang=js&"
export * from "./DeckImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports